import { alpha } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { tableRowClasses } from '@mui/material/TableRow';
// ----------------------------------------------------------------------
export function table(theme) {
    var _a, _b;
    return {
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    position: 'relative'
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: (_a = {},
                    _a["&.".concat(tableRowClasses.selected)] = {
                        backgroundColor: alpha(theme.palette.primary.dark, 0.04),
                        '&:hover': {
                            backgroundColor: alpha(theme.palette.primary.dark, 0.08)
                        }
                    },
                    _a['&:last-of-type'] = (_b = {},
                        _b["& .".concat(tableCellClasses.root)] = {
                            borderColor: 'transparent'
                        },
                        _b),
                    _a)
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottomStyle: 'dashed'
                },
                head: {
                    fontSize: 14,
                    color: theme.palette.text.secondary,
                    fontWeight: theme.typography.fontWeightSemiBold,
                    backgroundColor: theme.palette.background.neutral
                },
                stickyHeader: {
                    backgroundColor: theme.palette.background.paper,
                    backgroundImage: "linear-gradient(to bottom, ".concat(theme.palette.background.neutral, " 0%, ").concat(theme.palette.background.neutral, " 100%)")
                },
                paddingCheckbox: {
                    paddingLeft: theme.spacing(1)
                }
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    width: '100%'
                },
                toolbar: {
                    height: 64
                },
                actions: {
                    marginRight: 8
                },
                select: {
                    paddingLeft: 8,
                    '&:focus': {
                        borderRadius: theme.shape.borderRadius
                    }
                },
                selectIcon: {
                    right: 4,
                    width: 16,
                    height: 16,
                    top: 'calc(50% - 8px)'
                }
            }
        }
    };
}
